<template>
  <DraggableDialog
    :value="true"
    title="Dispêndios do Projeto"
    subtitle="Acompanhe os custos do projeto"
    initialWidth="500"
    initialHeight="auto"
    @close="close"
    @input="onInput"
  >
    <div class="dispendios-content pa-4">
      <div v-if="loading" class="text-center pa-4">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <!-- Colaboradores Section -->
        <div class="section mb-6">
          <h3 class="section-title mb-4">Colaboradores</h3>
          
          <v-row no-gutters class="mb-2">
            <v-col cols="8" class="text-subtitle-1">Quantidade de colaboradores</v-col>
            <v-col cols="4" class="text-right text-subtitle-1">{{ dispendios.colaboradores.quantidade }}</v-col>
          </v-row>
          
          <v-row no-gutters class="mb-4">
            <v-col cols="8" class="text-subtitle-1">Total de horas em P&D</v-col>
            <v-col cols="4" class="text-right text-subtitle-1">{{ formatNumber(dispendios.colaboradores.horas) }}</v-col>
          </v-row>

          <h4 class="subsection-title mb-2">Principais atividades</h4>
          
          <div v-if="dispendios.colaboradores.atividades && dispendios.colaboradores.atividades.length > 0">
            <v-row 
              v-for="(atividade, index) in dispendios.colaboradores.atividades" 
              :key="index" 
              no-gutters 
              class="mb-2 pl-4"
            >
              <v-col cols="8">{{ atividade.atividade }}</v-col>
              <v-col cols="4" class="text-right">{{ formatNumber(atividade.total_horas) }}</v-col>
            </v-row>
          </div>
          <div v-else class="pl-4 text-caption text-grey">
            Nenhuma atividade registrada.
          </div>
        </div>

        <!-- Terceiros Section -->
        <div class="section mb-6">
          <h3 class="section-title mb-4">Terceiros</h3>
          
          <v-row no-gutters class="mb-2">
            <v-col cols="8" class="text-subtitle-1">Quantidade de terceiros</v-col>
            <v-col cols="4" class="text-right text-subtitle-1">{{ dispendios.terceiros.quantidade }}</v-col>
          </v-row>
          
          <v-row no-gutters>
            <v-col cols="8" class="text-subtitle-1">Valor total em P&D</v-col>
            <v-col cols="4" class="text-right text-subtitle-1">{{ toCurrency(dispendios.terceiros.horas) }}</v-col>
          </v-row>
        </div>

        <!-- Materiais Section -->
        <div class="section">
          <h3 class="section-title mb-4">Materiais</h3>
          
          <v-row no-gutters>
            <v-col cols="8" class="text-subtitle-1">Quantidade de materiais</v-col>
            <v-col cols="4" class="text-right text-subtitle-1">{{ dispendios.materiais.quantidade }}</v-col>
          </v-row>
        </div>
      </div>
    </div>
  </DraggableDialog>
</template>

<script>
import DraggableDialog from "@/components/DraggableDialog.vue";
import DispendiosService from "@/services/dispendios.service";
import { toCurrency } from "@/helpers/toCurrency";

export default {
  props: {
    projectId: {
      type: Number,
      required: true
    },
    benefit: {
      type: Number,
      required: true
    }
  },
  components: {
    DraggableDialog
  },
  data() {
    return {
      loading: false,
      dispendiosService: new DispendiosService(),
      dispendios: {
        colaboradores: {
          quantidade: 0,
          horas: 0,
          atividades: []
        },
        terceiros: {
          quantidade: 0,
          horas: 0
        },
        materiais: {
          quantidade: 0
        }
      }
    }
  },
  methods: {
    toCurrency,
    close() {
      this.$emit('close');
    },
    onInput(val) {
      if (!val) this.close();
    },
    formatNumber(value) {
      if (value === undefined || value === null) return '0,0';
      return value.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
    async fetchDispendios() {
      this.loading = true;
      try {
        const response = await this.dispendiosService.getDispendios(this.projectId, { beneficio: this.benefit });
        this.dispendios = response.data;
      } catch (error) {
        console.error("Erro ao buscar dispêndios:", error);
        // this.$toast.error("Erro ao carregar dados de dispêndios."); // Uncomment if toast is available
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    projectId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchDispendios();
        }
      }
    },
    benefit: {
      handler() {
        this.fetchDispendios();
      }
    }
  },
  mounted() {
    // Fallback if immediate watch doesn't trigger on mount (it should, but safety first)
    if (this.projectId && !this.loading && this.dispendios.colaboradores.quantidade === 0) {
      this.fetchDispendios();
    }
  }
}
</script>

<style lang="scss" scoped>
.dispendios-content {
  color: #4a4a4a;
  font-size: 0.9rem; // Base size for data
}

.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #333;
}

.subsection-title {
  font-size: 1rem;
  font-weight: 600;
  color: #555;
}

.text-subtitle-1 {
  font-size: 0.9rem !important; // Reduced from 1rem
  color: #555;
}
</style>